/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForContainerFindingsParser extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForContainerFindingsParser");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForContainerFindingsParser.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForContainerFindingsParser>): BackgroundJobPayloadForContainerFindingsParser {
        let obj = Object.assign(new BackgroundJobPayloadForContainerFindingsParser(), model);
        BackgroundJobPayloadForContainerFindingsParser.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForContainerFindingsParser>): BackgroundJobPayloadForContainerFindingsParser {
        if (!model) return null;
        return BackgroundJobPayloadForContainerFindingsParser.newInstance(<BackgroundJobPayloadForContainerFindingsParser> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForContainerFindingsParser) {
        if (!obj) return;

        models.BackgroundJobPayloadForContainerFindingsParser.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForContainerFindingsParser): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForContainerFindingsParser.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Source tool from which the findings are ingested
     */
    findings_source_tool: models.SecurityFindingsSourceTool;

}
